// extracted by mini-css-extract-plugin
export var quantityInput = "_g4-0";